export class BankIdStatusRequest {
  Code: string;
  CustomerId?: string;

  constructor(code: string, customerId?: string) {
    this.Code = code;
    this.CustomerId = customerId;
  }
}
